"use client"
import React from 'react'
import { IoCall } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import useFetch from '@/app/useFetch'
import Link from 'next/link';
import { IMG_URL } from '@/app/config';
import { formatDateShort } from '@/app/helpers';
import { useTheme } from '@/app/theme-provider';
const RightInformation = () => {
    const{language}=useTheme()

    //  const [page, setPage] = useState(1);
    const { data: listoff, loadingoff, erroroff } = useFetch(
        "/website/general-information-rti-officers",
        // { page, limit: 5 }, // pass page & limit here
        []
    );

    //  const [page, setPage] = useState(1);
    const { data: listdata, loadingdata, errordata } = useFetch(
        "/website/general-information-rti-files",
        // { page, limit: 5 }, // pass page & limit here
        []
    );

    //  const [page, setPage] = useState(1);
    const { data: listdatadynamic, } = useFetch(
        "/website/general-information-rti-dynamic-content",
        // { page, limit: 5 }, // pass page & limit here
        []
    );




    return (
        <>
            <section className='mt-4'>
                 <h4 className='center'>{language=="en"?"SERVICES GIVEN BY VIGILANCE AND ANTI-CORRUPTION BUREAU":"വിജിലൻസ് ആൻഡ് ആന്റി-കൊറപ്ഷൻ ബ്യൂറോ നൽകുന്ന സേവനങ്ങൾ"}</h4>
                <div className="table-responsive tenders-table">
                   
                    <table className="table  table-bordered text-center align-middle ">
                        <thead className="thead-dark">
                            <tr>
                                <th scope="col">{language=="en"?"Sl No.":"ക്രമം നമ്പർ"}</th>
                                <th scope="col">{language=="en"?"Name and Designation":"പേരും പദവിയും"}</th>
                                <th scope="col">{language=="en"?"Designated Post":"നിയുക്ത പോസ്റ്റ്"}</th>
                                <th scope="col">{language=="en"?"Office No.":"ഓഫീസ് നം."}</th>
                                <th scope="col">{language=="en"?"Mobile No.":"മൊബൈൽ നമ്പർ."}</th>
                                <th scope="col">{language=="en"?"E-mail":"ഇ-മെയിൽ"}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {listoff?.length > 0 ? (
                                <>
                                    {listoff?.map((item, index) => (
                                        <>
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item?.name}<br />{`(${item?.designation})`}</td>
                                                <td>
                                                    {item?.designated_post}
                                                </td>
                                                <td>
                                                    {item?.office_no}
                                                </td>
                                                <td>
                                                    {item?.mobile_no}
                                                </td>
                                                <td>
                                                    {item?.email}
                                                </td>
                                            </tr>

                                        </>
                                    ))}

                                </>
                            ) : <>
                                <tr>
                                    <td colSpan={6}></td>
                                </tr>
                            </>}

                        </tbody>
                    </table>
                </div>
            </section>
            <section className='mt-4'>
                <h4 className='center'>{language=="en"?"Available under section 4(1) of the Right to Information Act, 2005":"2005 ലെ വിവരാവകാശ നിയമത്തിലെ സെക്ഷൻ 4(1) പ്രകാരം ലഭ്യമാണ്."}</h4>
                <div className="table-responsive tenders-table">
                    
                    <table className="table  table-bordered text-center align-middle ">
                        <thead className="thead-dark">
                            <tr>
                                <th scope="col">{language=="en"?"Sl No.":"ക്രമം നമ്പർ"}</th>
                                <th scope="col">{language=="en"?"Details":"വിശദാംശങ്ങൾ"}</th>
                                <th scope="col">{language=="en"?"View":"കാണുക"}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {listdata?.length > 0 ? (
                                <>
                                    {listdata?.map((item, index) => (
                                        <>
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td className='algndata'>{item?.name}</td>
                                                <td>
                                                    <Link target='blank' href={`${IMG_URL}${item.downloadfile}`}>
                                                        <button className=" ">
                                                            {language=="en"?"View":"കാണുക"}
                                                        </button>
                                                    </Link>
                                                </td>
                                            </tr>
                                        </>
                                    ))}
                                </>
                            ) : <>
                                <tr>
                                    <td colSpan={3}>No data found</td>
                                </tr>
                            </>}


                        </tbody>
                    </table>
                </div>
            </section>

            {listdatadynamic?.length > 0 && (
                <section className="mt-4">
                    <div className="table-responsive tenders-table">
                        {/* <h4 className="center">Additional Information</h4> */}
                        {listdatadynamic.map((item, index) => (
                            <div
                                key={item.id || index}
                                className="dynamic-table-content mt-3"
                                dangerouslySetInnerHTML={{
                                    __html: item.details.replace(
                                        /<table/g,
                                        '<table class="table table-bordered text-center align-middle"'
                                    ),
                                }}
                            />
                        ))}
                    </div>
                </section>
            )}
        </>
    )
}

export default RightInformation
